const linkToCopyText = (event) => {

    if (! $(event.target).parents('.hh-article-header-full').length
        && ! $(event.target).parents('.hh-article').length) {
        return;
    }

    const range = window.getSelection().getRangeAt(0);
    const rangeContents = range.cloneContents();
    const pageLink = 'Читайте на Правмире: ' + document.location.href;
    const helper = document.createElement("div");

    helper.appendChild(rangeContents);

    event.clipboardData.setData("text/plain", `${helper.innerText}\n${pageLink}`);
    event.clipboardData.setData("text/html", `${helper.innerHTML}<br>${pageLink}`);
    event.preventDefault();
};

document.addEventListener('copy', linkToCopyText);